<template>
  <div class="c-nav-slider__viewport" :class="{ 'c-nav-slider__viewport--primary': !level }" :style="{ transform: `translateX(${ isExpanded ? '-100%' : '0' })` }">
    <div class="c-nav-slider__up" v-if="level" @click="leave">{{ t('Back') }}</div>
    <slot name="slide-viewport-title"></slot>
    <div class="c-nav-slider__items">
      <slot></slot>
    </div>
  </div>
</template>
<script lang="ts">
import { Component, Prop } from 'vue-property-decorator';
import { EventBus } from '../helpers/bus';
import BaseComponent from './Base';

@Component
export default class NavSliderViewport extends BaseComponent {
  @Prop({ type: Number, required: true }) public readonly level: number;

  protected isExpanded: boolean = false;

  protected mounted(): void {
    EventBus.$on('mobileMenu:reset', this.onReset);
    EventBus.$on('mobileMenu:level:enter', this.onTouch);
    EventBus.$on('mobileMenu:level:leave', this.onTouch);
  }

  protected beforeUnmount() {
    EventBus.$off('mobileMenu:reset', this.onReset);
    EventBus.$off('mobileMenu:level:enter', this.onTouch);
    EventBus.$off('mobileMenu:level:leave', this.onTouch);
  }

  protected onReset(): void {
    this.isExpanded = false;
  }

  protected onTouch({ level }: { level: number, guid: string }): void {
    this.isExpanded = this.level < level;
  }

  protected leave() {
    EventBus.$emit('mobileMenu:level:leave', { level: this.level - 1 });
  }
}
</script>
